/*
 * @Description: 
 * @Author: dingxianzhi
 * @Email: dingxz@moofen.cn
 * @Date: 2022-09-05 18:04:32
 * @LastEditTime: 2022-09-06 09:16:01
 */
import Vue from 'vue'

export default new Vue()